export default {"src":"/_next/static/media/twitter-icon.3f176295.svg","height":16,"width":18};